import { togglePredicate } from "@portal/util/predicates";
import { useEffect, useState } from "react";

interface useOpenProps {
  open: boolean;
}

interface useOpenReturnType {
  open: boolean;
  toggleOpen: () => void;
  onClose: () => void;
  handleOpenChange: (open: boolean) => void;
}
function useOpen(props: Readonly<useOpenProps>): useOpenReturnType {
  const [open, setOpen] = useState<boolean>(false);
  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  function toggleOpen() {
    setOpen(togglePredicate);
  }

  function onClose() {
    setOpen(false);
  }
  function handleOpenChange(open: boolean) {
    setOpen(open);
  }
  return { open, toggleOpen, onClose, handleOpenChange };
}

export default useOpen;
